<template>
  <header class="header-container">
    <div class="header-container__hero">
      <div class="header-container__overlay"></div>
      <div class="header-container__hero-content">
        <h1>Znajdź usługę lub specjalistę dla swojego pupila</h1>
        <p>Weterynarze, behawioryści, groomerzy i usługi dla zwierząt — blisko Ciebie lub online.</p>
        <router-link to="/spec-browser" class="find-specialist-btn">
          Przeglądaj specjalistów
        </router-link>
      </div>
    </div>

    <div class="header-container__hsearch-bar-wrap">
      <HintComponent page-key="home_page" :absolute="true" />
      <h2>Czego potrzebuje Twój pupil?</h2>

      <div class="header-container__search-type-tabs" role="group" aria-label="Typ wyszukiwania">
        <button
            type="button"
            class="header-container__search-type-btn"
            :class="{ active: searchType === 'all' }"
            @click="searchType = 'all'"
        >
          Wszystko
        </button>
        <button
            type="button"
            class="header-container__search-type-btn"
            :class="{ active: searchType === 'services' }"
            @click="searchType = 'services'"
        >
          Usługi
        </button>
        <button
            type="button"
            class="header-container__search-type-btn"
            :class="{ active: searchType === 'specialists' }"
            @click="searchType = 'specialists'"
        >
          Specjaliści
        </button>
      </div>

      <div class="header-container__hsearch-bar">
        <InputVue
          type="search"
          :placeholder="searchPlaceholder"
          id="searchBarInput"
          v-model="name"
          @keyup.enter="handleSearch"
        />
        <InputVue
          type="search"
          placeholder="Miasto, dzielnica lub adres"
          id="locationInput"
          v-model="location"
          @keyup.enter="handleSearch"
        />
        <DropdownVue
          :items="states"
          placeholder="województwo"
          id="stateDropdown"
          v-model="state"
          @setChecked="(e) => state = e"
          help-message="Opcjonalnie"
        />
        <SearchFormButton @click="handleSearch">
          Szukaj
        </SearchFormButton>
      </div>

      <div class="header-container__popular-searches">
        <span>Popularne:</span>
        <button
            v-for="phrase in popularSearches"
            :key="phrase"
            type="button"
            @click="setPopularSearch(phrase)"
        >
          {{ phrase }}
        </button>
      </div>

      <HelpMessage text="Opcjonalnie wybierz specjalizację, aby zawęzić wyniki" />
      <div class="header-container__hservices-list">
        <button
            class="header-container__hservices-list__srv-btn"
            type="button"
            v-for="category in categories"
            :key="category.id"
            :class="{ active: currentCategory === category.id }"
            @click="toggleCategory(category.id)"
        >
          <span class="header-container__hservices-list__srv-label">{{ category.name }}</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios';
import DropdownVue from '@/components/Dropdown.vue';
import InputVue from '@/components/Input.vue';
import SearchFormButton from '@/components/HomeComponents/home/SearchFormButton.vue';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";
import HelpMessage from "@/components/HelpMessage.vue";

export default {
  name: 'SearchBarVue',
  setup() {
    return { appStore: useAppStore() };
  },
  data() {
    return {
      searchType: 'all',
      states: [],
      categories: [],
      currentCategory: '',
      state: 'placeholder',
      name: '',
      location: '',
      popularSearches: [
        'Weterynarz online',
        'Behawiorysta',
        'Groomer',
        'Szczepienie kota',
        'Dietetyk zwierzęcy'
      ]
    };
  },
  components: { HelpMessage, HintComponent, SearchFormButton, DropdownVue, InputVue },
  computed: {
    searchPlaceholder() {
      if (this.searchType === 'specialists') {
        return 'Np. behawiorysta, weterynarz, nazwisko specjalisty';
      }

      if (this.searchType === 'services') {
        return 'Np. szczepienie, konsultacja, grooming';
      }

      return 'Np. szczepienie, behawiorysta, groomer, nazwisko specjalisty';
    }
  },
  mounted() {
    this.getStatesAndCategories();
  },
  methods: {
    getStatesAndCategories() {
      axios.get('/State').then(res => {
        res.data.forEach((item) => this.states.push({ name: item.name, value: `${item.id}` }));
      });
      axios.get('/Categories').then(res => {
        res.data.forEach((item) => this.categories.push({ name: item.name, id: `${item.id}` }));
      });
    },
    toggleCategory(categoryId) {
      this.currentCategory = this.currentCategory === categoryId ? '' : categoryId;
    },
    setPopularSearch(phrase) {
      this.name = phrase;
    },
    getSearchPath() {
      if (this.searchType === 'specialists') {
        return '/spec-browser';
      }

      return '/browser';
    },
    setSearchParams() {
      this.$router.push({
        path: this.getSearchPath(),
        query: {
          type: this.searchType,
          q: this.name.trim(),
          name: this.name.trim(),
          location: this.location.trim(),
          state: this.state !== 'placeholder' ? this.state : '',
          category: this.currentCategory
        }
      });
    },
    handleSearch() {
      const hasQuery = this.name.trim().length > 0;
      const hasLocation = this.location.trim().length > 0;
      const hasState = this.state !== 'placeholder';
      const hasCategory = this.currentCategory !== '';

      if (!hasQuery && !hasLocation && !hasState && !hasCategory) {
        this.appStore.setIsAlert('Wpisz czego szukasz, podaj lokalizację lub wybierz specjalizację');
        return;
      }

      if (hasQuery && this.name.trim().length < 3) {
        this.appStore.setIsAlert('Wpisz minimum 3 znaki w polu wyszukiwania');
        return;
      }

      if (hasLocation && this.location.trim().length < 3) {
        this.appStore.setIsAlert('Wpisz minimum 3 znaki w lokalizacji');
        return;
      }

      this.setSearchParams();
    }
  }
};
</script>

<style scoped lang='scss'>
.header-container {
  margin-bottom: 32px;
  &__hero {
    position: relative;
    min-height: 520px;
    background-image: url('https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=1920&auto=format&fit=crop');
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(31, 41, 55, .62);
  }
  &__hero-content {
    position: relative;
    z-index: 1;
    max-width: 900px;
    text-align: center;
    color: #fff;
    padding: 40px 16px;
    h1 {
      font-size: clamp(3.2rem, 5vw, 5.8rem);
      line-height: 1.15;
      margin-bottom: 16px;
    }
    p {
      font-size: 2rem;
      margin-bottom: 24px;
      color: #e5e7eb;
    }
  }
  &__hsearch-bar-wrap {
    width: min(1100px, calc(100% - 32px));
    margin: -64px auto 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, .12);
    padding: 24px;
    position: relative;
    z-index: 5;
    h2 {
      text-align: center;
      margin-top: 0;
      margin-bottom: 18px;
      font-size: 3rem;
      color: #111827;
    }
  }
  &__search-type-tabs {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-bottom: 18px;
    flex-wrap: wrap;
  }
  &__search-type-btn {
    border: 1px solid #d1d5db;
    background: #fff;
    color: #374151;
    border-radius: 999px;
    padding: 9px 18px;
    font-size: 1.45rem;
    font-weight: 700;
    cursor: pointer;
    transition: border-color .2s ease, background .2s ease, color .2s ease, box-shadow .2s ease;

    &:hover {
      border-color: #10b981;
      color: #047857;
    }

    &.active {
      border-color: #10b981;
      background: #ecfdf5;
      color: #047857;
      box-shadow: 0 4px 12px rgba(16, 185, 129, .16);
    }
  }
  &__hsearch-bar {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr auto;
    gap: 16px;
    margin-bottom: 14px;
    align-items: end;
  }
  &__popular-searches {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    margin: 4px 0 18px;
    color: #6b7280;
    font-size: 1.35rem;

    span {
      font-weight: 700;
      color: #374151;
    }

    button {
      border: 0;
      background: #f3f4f6;
      color: #047857;
      border-radius: 999px;
      padding: 6px 12px;
      cursor: pointer;
      font-weight: 600;
      transition: background .2s ease, color .2s ease;

      &:hover {
        background: #d1fae5;
        color: #065f46;
      }
    }
  }
  &__hservices-list {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    text-align: center;
    &__srv-span {
      cursor: pointer;
      border: 1px solid #f3f4f6;
      border-radius: 8px;
      padding: 12px 14px;
      display: inline-block;
      transition: .2s;
      width: 100%;
      box-sizing: border-box;
      font-weight: 500;
      color: #374151;
      &.active,
      &:hover {
        border-color: #10b981;
        box-shadow: 0 4px 12px rgba(16, 185, 129, .12);
        color: #10b981;
      }
    }
    &__srv-btn {
      border: 1px solid #f3f4f6;
      background: #fff;
      border-radius: 10px;
      min-height: 58px;
      padding: 10px 14px;
      cursor: pointer;
      transition: border-color .2s ease, box-shadow .2s ease, transform .15s ease, color .2s ease;
      color: #374151;

      &:hover {
        border-color: #10b981;
        box-shadow: 0 6px 16px rgba(0, 0, 0, .08);
        transform: translateY(-1px);
      }

      &:focus {
        outline: none;
        border-color: #10b981;
        box-shadow: 0 0 0 1px #10b981, 0 0 0 4px rgba(16, 185, 129, .15);
      }

      &.active {
        border-color: #10b981;
        background: #ecfdf5;
        color: #047857;
        box-shadow: 0 6px 16px rgba(16, 185, 129, .2);
      }
    }
    &__srv-label {
      font-size: 1.6rem;
      font-weight: 500;
      line-height: 1.2;
      display: inline-block;
    }
  }
}
@media (max-width: 1100px) {
  .header-container__hsearch-bar {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 900px) {
  .header-container__hsearch-bar {
    grid-template-columns: 1fr;
  }
  .header-container__hservices-list {
    grid-template-columns: 1fr;
  }
  .header-container__hsearch-bar-wrap {
    width: auto;
  }
}
.find-specialist-btn {
  background: #ffffff;
  border-radius: 999px;
  padding: 12px 24px;
  margin-top: 20px;
  display: inline-block;
  color: #10b981;
  font-weight: 700;
  transition: .2s;
  text-decoration: none;
  &:hover {
    background: #f3f4f6;
    color: #10b981;
  }
}
</style>